/**
 * Zpráva s odpovědí z API služby v návaznosti na klientský dotaz
 * @includeToDoc
 */
export interface IResultMessage {
    /** Typ zprávy */
    readonly type: ResultMessageType;
    /** Obsah zprávy */
    readonly text: string;
    /** Lokalizační klíč obsahu zprávy (pod ním je uložen obsah atributu _text_) */
    readonly locKey: string;
}

/**
 * Typ zprávy z API služby
 * @includeToDoc
 */
export enum ResultMessageType {
    error = -1,
    warning = 1,
    information = 0,
    recommendation = 2,
}
